import React, { useEffect, useState, useRef,useMemo } from "react";
import BASEURL from "../Utils/Baseurl";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  Card,
  Grid2,
  Box,
  CardActions,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  Typography,
  Divider,
  List,
  ListItem,
  Button,

} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Add } from "@mui/icons-material";
import MaterialInput from "../../components/MaterialInput";
import MaterialSelect from "../../components/MasterSelect";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialBox from "../../components/MaterialBox";
import MaterialButton from "../../components/MaterialButton";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import { request } from "graphql-request";
import { useNavigate } from "react-router-dom";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import { toWords } from "number-to-words";
import keelLogo from "../../assest/images/Keel.png";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";
import Select from "react-select";
import { PDFDocument } from "pdf-lib";
import Swal from "sweetalert2";
import { useReactToPrint } from "react-to-print";
import './File.css'
const AddPayslip = () => {
  const navigate = useNavigate();
  const employeedata = sessionStorage.getItem("user");
  const userObject = JSON.parse(employeedata);
  const [assignedUsers, setAassignedUsers] = useState([]);
  const [payrollData, setPayrollData] = useState({
    month: "",
    monthStatus: "",
    year: "",
    yearStatus: "",
    empid: userObject.empid,
  });

  const currentYear = new Date().getFullYear();
  const startYear = 2000;
  const years = [];
 
  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const [selectedMonth, setSelectedMonth] = useState("");

  const monthss = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const payslipRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => payslipRef.current,
    documentTitle: "Payslip",
  });
  const [payrolldeatils, setpayrolldeatils] = useState([]);
  const [display, setdisplay] = useState(true);
  
  const downloadPDF = async () => {
    const element = payslipRef.current;
    const downloadButton = document.getElementById("downloadButton");
  
    if (downloadButton) downloadButton.style.display = "none";
  
    const canvas = await html2canvas(element, {
      scale: 3, 
      useCORS: true, 
    });

    const imageData = canvas.toDataURL("image/png");
    const pdfDoc = await PDFDocument.create();
    const image = await pdfDoc.embedPng(imageData);
    const imageWidth = 500; 
    const imageHeight = (image.height / image.width) * imageWidth; 
    const page = pdfDoc.addPage([imageWidth + 30, imageHeight + 30]); 
    page.drawImage(image, {
      x: 15, 
      y: 15,
      width: imageWidth,
      height: imageHeight,
    });

    const pdfBytes = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "payslip.pdf";
    link.click();

    if (downloadButton) downloadButton.style.display = "inline-block";
  };
  
  const staticKeys = [
    "EMPLOYEE NAME",
    "DESIGNATION",
    "DATE OF JOINING",
    "PAY DATE",
    "PAY PERIOD ",
    "PAN NUMBER",
    "PF A/C NUMBER",
    "UAN NUMBER",
    "ESI NUMBER ",
  ];

  const Earnings = [
    "BASIC PAY",
    "HOUSE RENT ALLOWANCE",
    "SPECIAL ALLOWANCE",
    "LTA ALLOWANCE",
    "Gross Earnings",
  ];
  const Deduction = [
    "PF AMOUNT",
    "ESIC Amount",
    "GRATUITY",
    "GROSS DEDUCTIONS",
  ];

  const EarningListTable = {
    columns: [
      {
        field: "id",
        headerName: "S No",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "firstName",
        headerName: "Employee Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      // {
      //     field: "empid",
      //     headerName: "Employee Code",
      //     flex: 1,
      //     editable: false,
      //     disableColumnMenu: true,
      //     sortable: true,
      // },
      {
        field: "gender",
        headerName: "Gender",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "fathersName",
        headerName: "Father’s Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "maritalStatus",
        headerName: "Marital Status ",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "dateOfBirth",
        headerName: "DOB",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "dateOfJoining",
        headerName: "DOJ",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "department",
        headerName: "Department",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "aadharNumber",
        headerName: "Aadhar Number",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "bankName",
        headerName: "Bank Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "accountNumber",
        headerName: "Account Number",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "panNumber",
        headerName: "PAN Number",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      // {
      //     field: "aadharNumber",
      //     headerName: "Official Email ID",
      //     flex: 1,
      //     editable: false,
      //     disableColumnMenu: true,
      //     sortable: true,
      // },
      {
        field: "lossOfPayAmount",
        headerName: "Loss of Pay Amount",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "totalDeductions",
        headerName: "Total Deduction",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "gross",
        headerName: "Total Gross",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "netPay",
        headerName: "Net Pay",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
    ],
    rows: payrolldeatils?.map((leave, index) => ({
      id: index + 1,
      firstName: leave.user.firstName,
      // empid: leave.user.empid,
      gender: leave.user?.gender,
      fathersName: leave.user.fathersName,
      maritalStatus: leave.user.maritalStatus,
      dateOfBirth: leave.user.dateOfBirth,
      dateOfJoining: leave.user.dateOfJoining,
      department: leave.user.department,
      aadharNumber: leave.user.aadharNumber,
      bankName: leave.bankDetails.bankName,
      accountNumber: leave.bankDetails.accountNumber,
      panNumber: leave.user.panNumber,
      lossOfPayAmount: leave.employeeSalary.lossOfPayAmount,
      totalDeductions: leave.employeeSalary.totalDeductions,
      gross: leave.employeeSalary.gross,
      netPay: leave.employeeSalary.netPay,
    })),
  };

  const getpayrolldata = async () => {
    const query = `query GetAllPayroll {
  allPayroll {
    user{
        id
        firstName
        lastName
      	gender
        fathersName
        maritalStatus
        aadharNumber
        department
        dateOfBirth
        dateOfJoining
      	panNumber
        uanNumber
        role
        bankDetails{
        accountNumber
        bankName
        ifscNumber
        branchName
        cifNumber
      }
      }
        updatedCtc
        gross
        totalDeductions
        totalBenefits
        netPay
        netpayWithOtammount
        overallSum
        oneDaySalary
        lossOfPayAmount
}
}
 
 
query GetPayrollById($id: String!) {
  payrollById(id: $id) {
    user{
        id
        firstName
        lastName
        empid
      	gender
        fathersName
        maritalStatus
        aadharNumber
        department
        dateOfBirth
        dateOfJoining
      	panNumber
        uanNumber
        role
        bankDetails{
        accountNumber
        bankName
        ifscNumber
        branchName
        cifNumber
      }
      }
        updatedCtc
        gross
        totalDeductions
        totalBenefits
        netPay
        netpayWithOtammount
        overallSum
        oneDaySalary
        lossOfPayAmount
}
}`;

    try {
    } catch (error) {}
  };

  const payrollSubmit = async () => {
    const query = `
        mutation payroll($month: Int!, $year: Int!) {
          FetchPayroll(month: $month, year: $year) {
            payrollData {
              user {
                id
                firstName
                lastName
                gender
                fathersName
                maritalStatus
                aadharNumber
                department
                dateOfBirth
                dateOfJoining
                panNumber
                uanNumber
              }
              bankDetails {
                accountNumber
                bankName
                ifscNumber
                branchName
                cifNumber
              }
              lossOfPayCount
              overtime
              otPerhourCharge
              OTAmount
              employeeSalary {
                ctc
                gross
                totalDeductions
                totalBenefits
                netPay
                netpayWithOtammount
                overallSum
                difference
                oneDaySalary
                lossOfPayAmount
                breakdown {
                  type
                  componentName
                  percentage
                  monthly
                  yearly
                }
              }
            }
            updatedCtcArray
          }
        }
      `;

    try {
      const variables = {
        month: payrollData.month.value,
        year: payrollData.year.value,
      };

      console.log("variables:", variables);

      const response = await axios.post(
        BASEURL,
        {
          query,
          variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.errors) {
        console.error("GraphQL Errors:", response.data.errors);
      } else {
        console.log(
          "Payroll Data:",
          response.data.data.FetchPayroll.payrollData
        );
        let data = response.data.data.FetchPayroll.payrollData;
        //   setpayrolldeatils(data)
        console.log("response.data:", response.data);
      }
    } catch (error) {
      console.error("Error fetching payroll data:", error.message);
    }
  };

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const currentMonth = new Date().getMonth() + 1; // Get the current month (0-based index, so add 1)
const months = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

// Filter only current and past months
const jobidlist = months.filter((month) => parseInt(month.value) <= currentMonth);
  
  const getPreviousMonthsInYear = () => {
    const monthNames = [
      { value: "01", label: "January" },
      { value: "02", label: "February" },
      { value: "03", label: "March" },
      { value: "04", label: "April" },
      { value: "05", label: "May" },
      { value: "06", label: "June" },
      { value: "07", label: "July" },
      { value: "08", label: "August" },
      { value: "09", label: "September" },
      { value: "10", label: "October" },
      { value: "11", label: "November" },
      { value: "12", label: "December" },
    ];
  
   
    const currentYear = new Date().getFullYear();
    const currentMonthIndex = new Date().getMonth();

    return monthNames.slice(0, currentMonthIndex + 1).map((month) => ({
      ...month,
      year: currentYear,
    }));
  };

  // const monthsOptions = getPreviousMonthsInYear();

  const monthNames = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];


  // const fetchUserAlreadyAssignedUser = async () => {
  //     const response = await fetch(BASEURL, {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({ query: ALL_ASSIGNED_USER }),
  //     });
  //     const data = await response.json();
  //     if (data.errors) {
  //         throw new Error(data.errors[0].message);
  //     }
  //     return data.data.allEmployeeSalery;
  // };

  // useEffect(_ => {
  //     const fetchData = async () => {
  //         try {
  //             const AssignedUsers = await fetchUserAlreadyAssignedUser();

  //             setAassignedUsers(AssignedUsers)
  //         } catch (error) {
  //             console.error("Error fetching components: ", error);
  //         }
  //     };
  //     fetchData();
  // }, [])



  const handleStructureDataChange = (event, selectEvent) => {
    let sourceState = { ...payrollData };

    // if (event?.target === undefined && selectEvent) {
    //   const lengthRegex = new RegExp("^[A-Za-z 0-9]");

    //   if (lengthRegex.test(event?.label) === true) {
    //     payrollState[selectEvent.name + "Status"] =
    //       event?.label === undefined ? "unchecked" : "success";
    //   } else {
    //     payrollState[selectEvent.name + "Status"] =
    //       selectEvent.value === "" ? "unchecked" : "error";
    //   }

    //   payrollState[selectEvent.name] = {
    //     value: event?.value || "",
    //     label: event?.label || "",
    //   };
    // }
    // setPayrollData({ ...payrollState });


    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "month") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "year") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      sourceState[selectEvent.name] = event;
    }


   setPayrollData(sourceState)
  
  }
  

  const [Earning, setEarning] = useState([]);
  const [Deductions, setDeductions] = useState([]);
  const [Benefits, setBenefits] = useState([]);
  const [Userdetails, setUserdetails] = useState("");
  const [totaldata, settotaldata] = useState("");
  const [Showpayslip, setShowpayslip] = useState(false);
  const Runpayslip = async () => {
    const query = `
     query payslip($empid: String!, $month: Int!, $year: Int!) {
        payslip(empid: $empid, month: $month, year: $year) {
          user {
            firstName
            lastName
            empid
            designation
            dateJoined
            panNumber
            uanNumber
            esicNumber
          }
          updatedCtc
          gross
          totalDeductions
          totalBenefits
          netPay
          netpayWithOtammount
          lossOfPayAmount
          overallSum
          otPerhourCharge
          overtime
    			lossOfPayCount
          breakdown
        }
}
    `;

console.log('currentMonth:',currentMonth);

    let varia = null;

    switch (selectedMonth) {
      case "January":
        varia = 1;
        break;
      case "February":
        varia = 2;
        break;
      case "March":
        varia = 3;
        break;
      case "April":
        varia = 4;
        break;
      case "May":
        varia = 5;
        break;
      case "June":
        varia = 6;
        break;
      case "July":
        varia = 7;
        break;
      case "August":
        varia = 8;
        break;
      case "September":
        varia = 9;
        break;
      case "October":
        varia = 10;
        break;
      case "November":
        varia = 11;
        break;
      case "December":
        varia = 12;
        break;
      default:
        console.error("No matching case found for:", currentMonth);
        return;
    }
    
    const variables = {
      month: varia,
      year: selectedYear,
      empid: userObject.empid,
    };

    console.log('variables:',variables);
    
  

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log('responseeeeee:',response.data);
      

      let payslipData = response.data.data.payslip;
      settotaldata(payslipData);
      if (response.data.data.payslip) {
        setShowpayslip(true);
      }
      if(response.data.data.payslip == null){
        Swal.fire({
          position: "center",
          icon: "error", // Change 'success' to 'error'
          title: "PaySlip is not generated this month",
          showConfirmButton: false,
          timer: 2500,
         
        });
        setShowpayslip(false);
        
      }
      // Parse the stringified JSON breakdown field
      const breakdown = JSON.parse(payslipData?.breakdown);
        console.log('breakdown:',breakdown);
        
      setUserdetails(payslipData.user);
      let earnings = breakdown.filter((val) => val.type == "Earnings");
      let deduction = breakdown.filter((val) => val.type == "Deductions");
      let benefits = breakdown.filter((val) => val.type == "Benefits");
      const gratuity = benefits.find(
        (item) => item.componentName === "GRATUITY"
      );
      const finalData = [...deduction, gratuity];

      setEarning(earnings);
      setDeductions(finalData);
      setBenefits(benefits);

     

      // Now you can use `breakdown` as a regular array
      breakdown.forEach((component) => {
        console.log(
          `Component Name: ${component.componentName}, Yearly: ${component.yearly}, Monthly: ${component.monthly}`
        );
      });
    } catch (error) {
      console.error("Error fetching payslip:", error);
    }
  };

  console.log("Earning:", Earning);
  console.log("Deductions:", Deductions);
  console.log("Benefits:", Benefits);
  console.log("Userdetails:", totaldata);
  const totalMonthly = Earning.reduce(
    (sum, earning) => sum + parseFloat(earning.monthly || 0),
    0
  );
  
  const totalYearly = Earning.reduce(
    (sum, earning) => sum + parseFloat(earning?.yearly || 0),
    0
  );
  const totalAmount = Deductions.reduce(
    (sum, deduction) => sum + (parseFloat(deduction?.yearly) || 0),
    0
  );
  
  const totalYTD = Deductions.reduce(
    (sum, deduction) => sum + (parseFloat(deduction?.monthly) || 0),
    0
  );
  const netPay = totaldata?.netpayWithOtammount;
  const amountInWords =
    typeof netPay === "number" && !isNaN(netPay) && netPay !== Infinity
      ? toWords(netPay)
      : "Invalid Amount";

      const checkAllFields = () => {
        let allowSubmit = false
        if (payrollData.monthStatus === 'success' && payrollData.yearStatus =='success') {
            allowSubmit = true
        }
        else {
            allowSubmit = false
        }
        return allowSubmit
    }

    console.log("payrollData:",payrollData);
    

    const handleScreenChange = (event, selectEvent) => {
      console.log("selectEvent:", selectEvent, event?.label);
      let sourceState = { ...payrollData };
  
      if (event?.target === undefined && selectEvent) {
        if (selectEvent.name === "month") {
          const lengthRegex = new RegExp("^[A-Za-z0-9]");
          if (lengthRegex.test(event?.label) === true) {
            sourceState[selectEvent.name + "Status"] =
              event?.label === undefined ? "unchecked" : "success";
          } else {
            sourceState[selectEvent.name + "Status"] =
              selectEvent.value === "" ? "unchecked" : "error";
          }
        }
  
      
        sourceState[selectEvent.name] = event;
      } else {
        const changeAllowed = true;
        switch (event.target.name) {
          case "candidatename":
            {
              const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
              // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');
  
              if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
                sourceState[event.target.name + "Status"] = "success";
              } else {
                sourceState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;
  
          case "date":
            {
              if (event.target.value?.trim()) {
                sourceState[event.target.name + "Status"] = "success";
                const dateOnly = event.target.value.split("T")[0];
              } else {
                sourceState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;
  
          case "position":
            {
              const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
              // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');
  
              if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
                sourceState[event.target.name + "Status"] = "success";
              } else {
                sourceState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;
          case "department":
            {
              const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
              // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');
  
              if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
                sourceState[event.target.name + "Status"] = "success";
              } else {
                sourceState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;
          case "interviewer":
            {
              const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
              // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');
  
              if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
                sourceState[event.target.name + "Status"] = "success";
              } else {
                sourceState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;
          case "comments":
            {
              const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,250})$");
              // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');
  
              if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
                sourceState[event.target.name + "Status"] = "success";
              } else {
                sourceState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;
        }
        if (changeAllowed) {
          sourceState[event.target.name] = event.target.value;
        }
      }
      setPayrollData(sourceState);
    };
  
   
 
     
    const handlemonth = (e)=>{
      let val = e.target.value
      setSelectedMonth(val)
      setShowpayslip(false)
    }
      

    
      

    
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ overflow: "visible" }}>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Generate Payslip
                </MaterialTypography>
              </Stack>

           {Showpayslip && (
               <Button
               id="downloadButton"
               onClick={downloadPDF}
               style={{
                 margin: "20px",
                 padding: "10px",
                 backgroundColor: "#007BFF",
                 color: "#fff",
                 border: "none",
                 borderRadius: "5px",
                 fontSize: "14px",
               }}
             >
               Download PDF
             </Button>
           )}
            </Stack>
          }
        />
        <CardContent>
          <MaterialBox>
            <Grid container spacing={1}>
            <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Year <span style={{color:"red"}}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                {/* <MaterialSelect
                  name="year"
                  value={payrollData.year}
                  onChange={handleStructureDataChange}
                  options ={yearOptions}
                  error={
                    payrollData.yearStatus === "uncheckedError" ? true : false
                  }
                  success={payrollData.yearStatus === "success" ? true : false}
                  // isClearable
                /> */}
            <div className="dropdown-container">
    
      <select
        value={selectedYear}
        onChange={(e) => setSelectedYear(e.target.value)}
        className="custom-select"
      >
        <option value="" disabled>Select...</option>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
                {payrollData.monthStatus === "uncheckedError" && (
                  <FormControl error>
                    <FormHelperText>Employee Name is required</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
              
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Month <span style={{color:"red"}}>*</span>
                  </MaterialTypography>
              
                {/* <MaterialSelect
                  name="month"
                  value={payrollData.month}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleStructureDataChange}
                  options={monthNames.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                 
                  error={
                    payrollData.monthStatus === "error" ? true : false
                  }
                  success={payrollData.monthStatus === "success" ? true : false}
                  // isClearable
                /> */}
                {/* <MaterialSelect
                                  name="month"
                                  value={payrollData.month}
                                  // customStyles={{ optionPadding: 20 }}
                                  onChange={handleScreenChange} //selectedValue, event
                                  options={jobidlist.map((value) => {
                                    return {
                                      value: value.value,
                                      label: value.label,
                                    };
                                  })}
                                  // error={feedback.hiringstatusStatus === "error" ? true : false}
                                  // success={
                                  //   feedback.hiringstatusStatus === "success" ? true : false
                                  // }
                                 
                                    // isDisabled={togglePage.view === true ? true : false}
                                  //   isClearable
                                /> */}
 
          

 <div className="dropdown-container">
     
      <select
        value={selectedMonth}
        onChange={handlemonth}
        className="custom-select"
      >
        <option value="" disabled>Select...</option>
        {monthss.map((month) => (
          <option key={month} value={month}>
            {month}
          </option>
        ))}
      </select>
    </div>









                {payrollData.monthStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Employee Name is required</FormHelperText>
                  </FormControl>
                )}
              </Grid>
           
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee ID
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput value={payrollData.empid} disabled={display} />

                {payrollData.monthStatus === "uncheckedError" && (
                  <FormControl error>
                    <FormHelperText>Employee Name is required</FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>

            <MaterialBox
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1%",
              }}
            >
              <MaterialButton
                variant="gradient"
                color="dark"
                //  disabled={!checkAllFields()}
                onClick={Runpayslip}
              >
                Submit
              </MaterialButton>
            </MaterialBox>
          </MaterialBox>

          {Showpayslip && (
            <Card sx={{ marginTop: 3, boxShadow: 2 }}>
              <Grid2
                container
                spacing={2}
                size={12}
                sx={{
                  margin: "20px",
                  padding: { xs: "10px", md: "20px" },
                  fontSize: "14px",
                }}
                ref={payslipRef}
              >
                <Grid2 container size={12} xs={12} md={12}>
                  <Grid2
                    size={6}
                    display={"flex"}
                    flexDirection={"column"}
                    xs={6}
                  >
                    <header style={{ fontSize: "24px", fontWeight: "bold" }}>
                      KEEL INFO SOLUTION PVT LTD
                    </header>
                    <Typography variant="body2">CHENNAI,</Typography>
                    <Typography variant="body2">TAMILNADU 600126</Typography>
                  </Grid2>

                  <Grid2
                    item
                    xs={6}
                    display={"flex"}
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    sx={{ width: { lg: "30%" } }}
                  >
                    <img
                      src={keelLogo}
                      alt="Keel"
                      style={{ maxWidth: "100px", height: "auto" }}
                    />
                  </Grid2>

                  <Grid2 sx={{ marginLeft: "-2%" }} size={12}>
                    <Divider
                      sx={{
                        height: 3,
                        backgroundColor: "#3F51B5d4",
                        marginY: 2,
                      }}
                    />
                  </Grid2>
                </Grid2>

                {/* Payslip Title */}
                <Grid
                  container
                  justifyContent="center"
                  sx={{ marginBottom: 1 }}
                >
                  <Grid item xs={12} md={6}>
                    {/* Payslip Header */}
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: "bold",
                        textAlign: "left",
                        marginBottom: 1,
                      }}
                    >
                     {` Payslip for the month of ${selectedMonth} ${selectedYear}`}
                    </Typography>

                    {/* Employee Pay Summary */}
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        textAlign: "left",
                        marginBottom: 0,
                        color: "darkslategray",
                        fontSize: "18px",
                      }}
                    >
                      Employee Pay Summary
                    </Typography>

                    {/* Pay Details */}
                    <List
                      sx={{
                        width: "100%",
                        maxWidth: "600px",
                        // backgroundColor: 'background.paper',
                        // border: '1px solid #ddd',
                        borderRadius: "8px",
                        // boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                        padding: "5px",
                      }}
                    >
                      <ListItem
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "150px auto",
                          gap: 1.5,
                          alignItems: "center",
                          padding: "12px 0",
                        }}
                      >
                        {/* EMPLOYEE NAME */}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "600", color: "#abb2b9" }}
                        >
                          EMPLOYEE NAME
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#333 " }}>
                          {Userdetails.firstName?.toUpperCase()}
                        </Typography>

                        {/* DESIGNATION */}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "600", color: "#abb2b9" }}
                        >
                          DESIGNATION
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#333" }}>
                          {Userdetails.designation?.toUpperCase()}
                        </Typography>

                        {/* DATE OF JOINING */}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "600", color: "#abb2b9" }}
                        >
                          DATE OF JOINING
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#333" }}>
                          {(() => {
                            const date = new Date(Userdetails.dateJoined);
                            const day = String(date.getDate()).padStart(2, "0");
                            const month = String(date.getMonth() + 1).padStart(
                              2,
                              "0"
                            ); // Months are zero-based
                            const year = date.getFullYear();
                            return `${day}/${month}/${year}`;
                          })()}
                        </Typography>

                        {/* PAY DATE */}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "600", color: "#abb2b9" }}
                        >
                          PAY DATE
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#333" }}>
                          0.00
                        </Typography>

                        {/* PAY PERIOD */}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "600", color: "#abb2b9" }}
                        >
                          PAY PERIOD
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#333" }}>
                          PERIOD
                        </Typography>

                        {/* PF AC/NUMBER */}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "600", color: "#abb2b9" }}
                        >
                          PF AC/NUMBER
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "#333" }}
                        ></Typography>

                        {/* UAN NUMBER */}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "600", color: "#abb2b9" }}
                        >
                          UAN NUMBER
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#333" }}>
                          {Userdetails.uanNumber}
                        </Typography>

                        {/* ESI NUMBER */}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "600", color: "#abb2b9" }}
                        >
                          ESI NUMBER
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "#333" }}
                        ></Typography>
                      </ListItem>
                      <Divider />
                    </List>
                  </Grid>
                </Grid>

                {/* Employee Net Pay Section */}
                <Grid2
                  item
                  xs={12}
                  md={6}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      padding: "16px 73px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "100%",
                      backgroundColor: "#ffffff",
                      textAlign: "center",
                      marginBottom: "18%",
                      // boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                    }}
                  >
                    {/* Employee Net Pay Title */}
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#777",
                        fontWeight: "500",
                        marginBottom: "8px",
                      }}
                    >
                      Employee Net Pay
                    </Typography>

                    {/* Net Pay Amount */}
                    <Typography
                      variant="h5"
                      sx={{
                        color: "#27ae60",
                        fontWeight: "bold",
                        fontSize: "1.8rem",
                        marginBottom: "8px",
                      }}
                    >
                      {totaldata?.netpayWithOtammount}
                    </Typography>

                    {/* Paid Days and LOP Days */}
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#777",
                        fontWeight: "400",
                        fontSize: "0.9rem",
                      }}
                    >
                    Total OT Hrs : {totaldata?.overtime} | LOP Count :{" "}
                      <strong>{totaldata?.lossOfPayCount}</strong>
                    </Typography>
                  </Box>
                </Grid2>

                <Grid2 sx={{ marginLeft: "-2%" }} size={12}>
                  <Divider
                    sx={{
                      height: 2.5,
                      backgroundColor: "#3F51B5d4",
                      marginY: 2,
                      marginTop: "-6%",
                    }}
                  />
                </Grid2>

                {/* Earnings Table */}
                <Grid2 container spacing={3} marginTop={-5}>
                  {/* Earnings Table */}
                  <Grid2 item xs={12} md={6}>
                  <table style={{ borderCollapse: "collapse", width: "123%" }}>
    <thead>
      <tr 
        style={{
          backgroundColor: "#f0f0f0",
          fontWeight: "",
        }}
      >
        <th style={{ border: "1px solid #ddd", padding: "12px" }}>Earnings</th>
        <th style={{ border: "1px solid #ddd", padding: "5px" }}>Actuals</th>
        <th style={{ border: "1px solid #ddd", padding: "5px" }}>Amount</th>
        <th style={{ border: "1px solid #ddd", padding: "5px" }}>YTD</th>
      </tr>
    </thead>
    <tbody>
      {Earning.map((earning, index) => (
        <tr
          key={index}
          style={{
            backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
            fontSize: "14px",
          }}
        >
          <td style={{ padding: "5px", border: "1px solid #ddd" }}>
            {earning?.componentName}
          </td>
          <td style={{ padding: "5px", border: "1px solid #ddd" }}>
            {earning?.monthly}
          </td>
          <td style={{ padding: "5px", border: "1px solid #ddd" }}>
            {earning?.monthly}
          </td>
          <td style={{ padding: "5px", border: "1px solid #ddd" }}>
            {earning?.yearly}
          </td>
        </tr>
      ))}
      {/* GROSS EARNINGS ROW */}
      <tr
        style={{
          fontWeight: "bold",
          backgroundColor: "#f0f0f0",
        }}
      >
        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
        Gross Earnings
        </td>
        <td style={{ padding: "6px", border: "1px solid #ddd" }}>
          {totalMonthly.toFixed(2)}
        </td>
        <td style={{ padding: "6px", border: "1px solid #ddd" }}>
          {totalMonthly.toFixed(2)}
        </td>
        <td style={{ padding: "6px", border: "1px solid #ddd" }}>
          {totalYearly.toFixed(2)}
        </td>
      </tr>
    </tbody>
  </table>
                  </Grid2>

                  {/* Deductions Table */}
                  <Grid2 item xs={12} md={6}>
                  <table
    style={{
      width: "132%",
      borderCollapse: "collapse",
      textAlign: "center",
      marginLeft: "23%",
    }}
  >
    <thead>
      <tr
        style={{
          backgroundColor: "#f0f0f0",
          fontWeight: "bold",
        }}
      >
        <th
          style={{
            padding: "12px",
            border: "1px solid #ddd",
          }}
        >
          Deductions
        </th>
        <th
          style={{
            padding: "12px",
            border: "1px solid #ddd",
          }}
        >
          Amount
        </th>
        <th
          style={{
            padding: "12px",
            border: "1px solid #ddd",
          }}
        >
          YTD
        </th>
      </tr>
    </thead>
    <tbody>
      {/* Display Deductions */}
      {Deductions.map((deduction, index) => (
        <tr
          key={index}
          style={{
            backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
            fontSize: "14px",
          }}
        >
          <td
            style={{
              padding: "5px",
              border: "1px solid #ddd",
            }}
          >
            {deduction?.componentName + " - Amount"}
          </td>
          <td
            style={{
              padding: "5px",
              border: "1px solid #ddd",
            }}
          >
            {deduction?.yearly}
          </td>
          <td
            style={{
              padding: "5px",
              border: "1px solid #ddd",
            }}
          >
            {deduction?.monthly}
          </td>
        </tr>
      ))}
      {/* Display Gross Deductions */}
      <tr
        style={{
          backgroundColor: "#f0f0f0",
          fontWeight: "bold",
        }}
      >
        <td
          style={{
            padding: "12px",
            border: "1px solid #ddd",
          }}
        >
          Gross Deductions
        </td>
        <td
          style={{
            padding: "12px",
            border: "1px solid #ddd",
          }}
        >
          {totalAmount.toFixed(2)}
        </td>
        <td
          style={{
            padding: "12px",
            border: "1px solid #ddd",
          }}
        >
          {totalYTD.toFixed(2)}
        </td>
      </tr>
    </tbody>
  </table>
                  </Grid2>
                </Grid2>

                {/* Total Net Payable Section */}
                <div
                  style={{
                    width: "97%",
                    height: "60px",
                    backgroundColor: "#45a049",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "left",
                    margin: "20px 0",
                    borderRadius: "8px",
                    fontSize: "15px",
                    fontWeight: "600",
                    // boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    padding: "10px 20px",
                    textTransform: "uppercase",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#45a049")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "#4CAF50")
                  }
                >
                  {`Total Net Payable: ₹${totaldata?.netpayWithOtammount} (${
                    amountInWords.charAt(0).toUpperCase() +
                    amountInWords.slice(1)
                  })`}
                </div>

                <Grid2 sx={{ marginLeft: "-2%" }} size={12}>
                  <Divider
                    sx={{ height: 3, backgroundColor: "#3F51B5d4", marginY: 2 }}
                  />
                </Grid2>

                {/* Download PDF Button */}
              </Grid2>
              
            </Card>
          )}

          {/* <MaterialBox width="100%" sx={{ gap: 2 }} display="flex" justifyContent="flex-end">
                        <MaterialButton
                            variant="gradient"
                            color="dark"
                            // disabled={
                            //     !handleActiveStep()
                            // }
                            onClick={handleCancel}
                        >
                            cancel
                        </MaterialButton>
                        <MaterialButton
                            variant="gradient"
                            color="dark"
                            // disabled={
                            //     !handleActiveStep()
                            // }
                            onClick={handleAddPayroll}
                        >
                            submit
                        </MaterialButton>
                    </MaterialBox> */}
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default AddPayslip;
